import { useMemo } from 'react'

import { Box } from '@mantine/core'

import { useIsMobile } from 'hooks/useIsMobile'
import { Article, ArticleDisplayType } from 'interfaces/types'

import { CarouselOrListingBlockWrapper } from '../../carouselOrListingBlockWrapper'
import { SingleNormalLayout } from '../singleNormalLayout'

type Props = {
  layout?: ArticleDisplayType
  adUnitPath?: string
  articles: Article[]
  dataTrackingCommon: any
}

export const SliderNormalLayout = ({
  layout,
  articles,
  adUnitPath,
  dataTrackingCommon,
}: Props) => {
  const isMobile = useIsMobile()
  const perSlide = useMemo(() => (isMobile ? 4 : 6), [isMobile, articles])
  return (
    <CarouselOrListingBlockWrapper
      showFullSlide={!isMobile}
      lengthToCarouselDesktop={2}
      percentOfEndSlideMobile={88}
      lazyLoad
      carouselSetting={{
        loop: false,
      }}
    >
      <CarouselOrListingBlockWrapper.Slider>
        {[...new Array(Math.ceil(articles.length / perSlide))].map(
          (_i, idx) => (
            <Box key={idx}>
              <SingleNormalLayout
                articles={articles.slice(
                  idx * perSlide,
                  idx * perSlide + perSlide,
                )}
                layout={isMobile ? 'list-contain-ads' : layout}
                adUnitPath={adUnitPath}
                dataTrackingCommon={dataTrackingCommon}
              />
            </Box>
          ),
        )}
      </CarouselOrListingBlockWrapper.Slider>
    </CarouselOrListingBlockWrapper>
  )
}
